import { NavLink } from "react-router-dom";
import { Home, Sun, BookOpen, Compass, Grid3X3 } from "lucide-react";
import { useApp } from "../context/AppContext";

const items = (t) => [
  { to: "/", icon: Home, label: t.home, testid: "nav-home", end: true },
  { to: "/prayer", icon: Sun, label: t.prayer, testid: "nav-prayer" },
  { to: "/quran", icon: BookOpen, label: t.quran, testid: "nav-quran" },
  { to: "/qibla", icon: Compass, label: t.qibla, testid: "nav-qibla" },
  { to: "/more", icon: Grid3X3, label: t.more, testid: "nav-more" }
];

export default function BottomNav() {
  const { t } = useApp();
  return (
    <nav
      className="fixed bottom-0 inset-x-0 z-40 bg-white/95 backdrop-blur border-t border-[rgba(29,158,117,0.18)]"
      data-testid="bottom-nav"
    >
      <div className="max-w-5xl mx-auto grid grid-cols-5">
        {items(t).map(({ to, icon: Icon, label, testid, end }) => (
          <NavLink
            key={to}
            to={to}
            end={end}
            data-testid={testid}
            className={({ isActive }) =>
              `flex flex-col items-center justify-center gap-1 py-2.5 text-[11px] font-medium transition-colors ${
                isActive ? "bottom-nav-active" : "text-nour-text2 hover:text-nour-primary"
              }`
            }
          >
            <Icon className="w-5 h-5" />
            <span>{label}</span>
          </NavLink>
        ))}
      </div>
    </nav>
  );
}
